<template>
  <div>
    <div class="content-slide-details content-slide">
      <transition-group name="fade" tag="div" class="transition-content">
        <div v-for="i in [currentIndex]" :key="i" class="content-slide">
          <!-- hello
            <img :src="require(`@/assets/png/${currentImg}`)" /> -->
          <div class="slide-backroung-details test">
            <img :src="currentImg" class="slide-backroung-details test" />

            <div class="container-title-slide"></div>
          </div>
        </div>
      </transition-group>
      <div class="other-img" style="position: relative">
        <template v-for="(img, index) in DetailsAncienBien.pictureUrls">
          <div class="container-other-img" :key="index">
            <img
              :src="img"
              class="content-other-img"
              :class="currentImg == img ? 'img-active' : ''"
            />
          </div>
        </template>
        <a class="prev" @click="prev" href="#">&#10094; </a>
        <a class="next" @click="next" href="#">&#10095; </a>
      </div>
    </div>

    <div class="content-details-adresse">
      <div>
        <p class="content-title">{{ DetailsAncienBien.title }} </p>
        <p class="content-type"  style="width: 50%;    color: #111212;"> <template v-if=" DetailsAncienBien.category=='flat'"> Terrain</template> 
        <template v-else> Maisso</template> 
         </p>
        <p class="content-type mt-5" style="margin-top:10px;    color: #111212;">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 33.899 35.835" style="    color: #111212;">
                <g id="user-symbol-of-thin-outline" transform="translate(-20.85 0.5)">
                <g id="Groupe_3" data-name="Groupe 3" transform="translate(21.35)">
                    <g id="Groupe_1" data-name="Groupe 1" transform="translate(7.382)">
                    <path id="Tracé_1" data-name="Tracé 1" d="M193.219,18.138a9.069,9.069,0,1,1,9.074-9.069A9.078,9.078,0,0,1,193.219,18.138Zm0-17.24a8.174,8.174,0,1,0,8.171,8.171A8.182,8.182,0,0,0,193.219.9Z" transform="translate(-184.15)" fill="#111212" stroke="#111212" stroke-width="1"/>
                    </g>
                    <g id="Groupe_2" data-name="Groupe 2" transform="translate(0 21.127)">
                    <path id="Tracé_2" data-name="Tracé 2" d="M54.248,479.608H21.377l-.027-5.514a8.257,8.257,0,0,1,1.823-5.21,8.431,8.431,0,0,1,4.571-2.916l.05-.014h.054l19.975-.054.059.018a8.784,8.784,0,0,1,4.507,3,8.351,8.351,0,0,1,1.855,5.174l0,5.519Zm-31.978-.893h31.08v-4.621a7.453,7.453,0,0,0-1.66-4.616A7.917,7.917,0,0,0,47.7,466.8l-19.8.054a7.515,7.515,0,0,0-4.031,2.589,7.365,7.365,0,0,0-1.628,4.648Z" transform="translate(-21.35 -465.9)" fill="#111212" stroke="#111212" stroke-width="1"/>
                    </g>
                </g>
                </g>
            </svg>  Type d'annonceur : {{ DetailsAncienBien.sellerType }} 
        </p>

        <!--  <p class="left">
          <b-icon
            icon="geo-alt-fill"
            variant="dark"
            class=""
            style="margin-right: 2px"
          ></b-icon>
          Adresse : <strong> {{data.adresse}} </strong>
        </p> -->
      </div>
      <div>
        <div class="details-prix">{{ DetailsAncienBien.price }} €</div>
        <div class="mt-4">
             <a class="alert   " target="_blank" :href="DetailsAncienBien.url" style="    color: #22abc5;" > 

          
              Voir Annonce
              <fa-icon :icon="{ prefix: 'fas', iconName: 'chevron-right' }" />
            
          </a>
        </div>
      </div>
    </div>

    <div class="content-details-description">
      <div class="content-details-description-mobile">
        
        <p class="content-title-description" style>Détails</p>
        <div style="display: flex" class="content-title-description-mobile row">
          <div class="col-4 card-details">
            <b-icon
              icon="aspect-ratio"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Surface <br />
            <span class="value-details">
              {{ DetailsAncienBien.surface }} m²
            </span>
          </div>
          <div class="col-4 card-details">
            <b-icon
              icon="fullscreen"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Pièces <br />
            <span class="value-details"> {{ DetailsAncienBien.rooms }} </span>
          </div>
          <!-- <div class="col-4 card-details">
            <b-icon
              icon="star-fill"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Chambres <br /><span class="value-details"> {{data.piece}} </span>
          </div> -->

          <div class="col-4 card-details">
            <b-icon
              icon="life-preserver"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
             chambres <br />
            <span class="value-details">
              {{ DetailsAncienBien.bedrooms }}
            </span>
          </div>

                                  

          <div class="col-4 card-details" v-if="DetailsAncienBien.buildingFloors!=null">
            <i class="	far fa-building"></i> 
             étages <br>
             <span
              class="value-details"
              
            >
              {{DetailsAncienBien.buildingFloors}}
            </span>
            
          </div>
          <div class="col-4 card-details">
            <b-icon
              icon="truck"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Garage <br />
            <span
              class="value-details"
              v-if="DetailsAncienBien.options.includes('hasGarage')"
            >
              1
            </span>
            <span class="value-details" v-else> </span>
          </div>
          <div class="col-4 card-details">
            <b-icon
              icon="signpost2-fill"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Garage <br />
            <span
              class="value-details"
              v-if="DetailsAncienBien.options.includes('hasGarage')"
            >
              1
            </span>
            <span class="value-details" v-else> </span>
          </div>
          <div class="col-4 card-details">
            <b-icon
              icon="puzzle"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Parking<br />
            <span
              class="value-details"
              v-if="DetailsAncienBien.options.includes('hasParking')"
            >
              1
            </span>
            <span class="value-details" v-else> </span>
          </div>
          <div class="col-4 card-details">
            <b-icon
              icon="puzzle"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Cave<br />
            <span
              class="value-details"
              v-if="DetailsAncienBien.options.includes('hasCave')"
            >
              1
            </span>
            <span class="value-details" v-else> </span>
          </div>

          <div class="col-4 card-details">
            <b-icon
              icon="puzzle"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Piscine<br />
            <span
              class="value-details"
              v-if="DetailsAncienBien.options.includes('hasPool')"
            >
              1
            </span>
            <span class="value-details" v-else> </span>
          </div>
          <div class="col-4 card-details">
            <b-icon
              icon="tree-fill"
              variant="dark"
              class=""
              style="margin-right: 2px"
            ></b-icon>
            Jardin<br />
            <span
              class="value-details"
              v-if="DetailsAncienBien.options.includes('hasGarden')"
            >
              1
            </span>
            <span class="value-details" v-else> </span>
          </div>
        </div>
        <!-- <p class="content-title-description">Description</p>
        <p class="content-title-desc" >
          <p class="data-desc" v-html="data.description"> </p>
        </p> -->

        <p class="content-title-description mt-2">
          Informations additionnelles
        </p>
        <p class="content-title-desc">
          {{ DetailsAncienBien.description }}
        </p>
        <div class="content-card-details" style="    justify-content: center;">
          <div
            style="display: flex;text-align: center;    width: 300px;display:block !important;    padding: 5px;    color: #22abc5;font-weight: 700;"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16.5"
              height="18"
              viewBox="0 0 16.5 22"
              style="margin-bottom: 10px;"
            >
              <path
                id="Icon_awesome-map-marker-alt"
                data-name="Icon awesome-map-marker-alt"
                d="M7.4,21.556C1.159,12.505,0,11.576,0,8.25a8.25,8.25,0,0,1,16.5,0c0,3.326-1.159,4.255-7.4,13.306a1.032,1.032,0,0,1-1.7,0Zm.848-9.869A3.438,3.438,0,1,0,4.813,8.25,3.437,3.437,0,0,0,8.25,11.688Z"
                fill="#ff8c00"
              />
            </svg>
            <br />

            {{ DetailsAncienBien.location.city }} ({{
              DetailsAncienBien.location.postalCode
            }})
            <br />
            {{ DetailsAncienBien.location.population }} hab
            <br />
            Taxe foncière : {{ DetailsAncienBien.location.propertyTaxRate }} %
          </div>
          <div
            style="display: flex;text-align: center;    width: 300px; display:block !important;    padding: 5px;    color: #22abc5;font-weight: 700;"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="18"
              viewBox="0 0 22 22"
              style="margin-right: 15px;vertical-align: bottom;margin-bottom: 10px;"
            >
              <path
                id="Icon_material-euro-symbol"
                data-name="Icon material-euro-symbol"
                d="M19.167,23.444a7.92,7.92,0,0,1-7.04-4.278h7.04V16.722H11.32a7.688,7.688,0,0,1,0-2.444h7.847V11.833h-7.04a7.929,7.929,0,0,1,12.21-2.359L26.5,7.311A10.984,10.984,0,0,0,8.8,11.833H4.5v2.444H8.24a10.222,10.222,0,0,0,0,2.444H4.5v2.444H8.8a10.984,10.984,0,0,0,17.7,4.522l-2.176-2.163a7.829,7.829,0,0,1-5.158,1.919Z"
                transform="translate(-4.5 -4.5)"
                fill="#ff8c00"
              />
            </svg>
            <br />
            {{ parseFloat(DetailsAncienBien.price).toLocaleString("fr") }} €
            <br />
            <template v-if="DetailsAncienBien.priceStats">
              Loyer estimé :
              {{
                parseFloat(
                  DetailsAncienBien.priceStats.lowPrice
                ).toLocaleString("fr")
              }}
              €
              <br />
              Rentabilité brute :
              {{
                parseFloat(
                  DetailsAncienBien.priceStats.profitability
                ).toLocaleString("fr")
              }}
              %
            </template>
          </div>
          <div
            style="display: flex;text-align: center;    width: 300px;display:block !important;    padding: 5px;    color: #22abc5;font-weight: 700;"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="18"
              viewBox="0 0 24 24"
              style="margin-right: 15px;vertical-align: bottom;margin-bottom: 10px;"
            >
              <path
                id="Icon_awesome-ruler-combined"
                data-name="Icon awesome-ruler-combined"
                d="M7.5,13.5H4.875a.375.375,0,0,1-.375-.375v-.75A.375.375,0,0,1,4.875,12H7.5V9H4.875A.375.375,0,0,1,4.5,8.625v-.75A.375.375,0,0,1,4.875,7.5H7.5v-3H4.875A.375.375,0,0,1,4.5,4.125v-.75A.375.375,0,0,1,4.875,3H7.5V1.5A1.5,1.5,0,0,0,6,0H1.5A1.5,1.5,0,0,0,0,1.5v21a1.443,1.443,0,0,0,.074.366L7.5,15.44Zm15,3H21v2.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375V16.5h-3v2.625a.375.375,0,0,1-.375.375h-.75A.375.375,0,0,1,15,19.125V16.5H12v2.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375V16.5H8.561L1.134,23.926A1.447,1.447,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V18A1.5,1.5,0,0,0,22.5,16.5Z"
                fill="#ff8c00"
              />
            </svg>
            <br />

            {{ DetailsAncienBien.surface }} m2 (
            {{
              parseFloat(DetailsAncienBien.pricePerSquareMeter).toLocaleString(
                "fr"
              )
            }}
            €/ m²)
            <br />
            <template v-if="DetailsAncienBien.priceStats">
              Prix bas :
              {{
                parseFloat(
                  DetailsAncienBien.priceStats.lowPrice
                ).toLocaleString("fr")
              }}
              € / m²
              <br />
              Prix médian :
              {{
                parseFloat(
                  DetailsAncienBien.priceStats.medianPrice
                ).toLocaleString("fr")
              }}
              € / m²
              <br />
              Prix haut :
              {{
                parseFloat(
                  DetailsAncienBien.priceStats.highPrice
                ).toLocaleString("fr")
              }}
              € / m²
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: ["data"],
  name: "Achter",
  data() {
    return {
      currentIndex: 0,
      timer: null,
    };
  },

  mounted: function() {
    this.getBienAncienById({ id: this.$route.params.id }).then(() => {
      this.startSlide();
    });
  },

  methods: {
    ...mapActions(["getBienAncienById"]),
    startSlide: function() {
      //  this.timer = setInterval(this.next, 4000);
    },

    next: function() {
      this.currentIndex += 1;
    },
    prev: function() {
      this.currentIndex -= 1;
    },
  },

  computed: {
    ...mapGetters(["DetailsAncienBien"]),
    currentImg: function() {
      if (
        this.DetailsAncienBien != null &&
        this.DetailsAncienBien.pictureUrls != undefined
      ) {
        return this.DetailsAncienBien.pictureUrls[
          Math.abs(this.currentIndex) %
            this.DetailsAncienBien.pictureUrls.length
        ];
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
.data-desc {
  text-align: left;
}
.card-details {
  background-color: white;
  width: 15%;
  margin-right: 10px;
  padding: 4px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 12px;
  height: 63px;
}
.content-title-vendeur {
  color: #242424;
  font-size: 19px;
  font-family: "Poppins";
  font-weight: 600;
  margin: 0;
  text-align: left;
}
.left {
  text-align: left;
}

.content-title-desc {
  color: #242424;
  font-size: 15px;
  font-family: "Poppins";
  margin: 0;
  display: flex;

  text-align: left;
  text-overflow: ellipsis;
  word-wrap: break-word;
  hyphens: auto;
  font-family: "Poppins";
  margin-top: 19px;
}
.content-title-description {
  color: #242424;
  font-size: 19px;
  font-family: "Poppins";
  font-weight: 600;
  margin: 0;
  display: flex;
}
.content-type {
  background-color: #70707029;
  padding: 8px;
  border-radius: 5px;
  color: #2da9c5;
  font-family: "Poppins";
  margin-bottom: 10px;
  font-size: 15px;
  margin: 0;
}
.content-title {
  color: #242424;
  font-size: 25px;
  font-family: "Poppins";
  font-weight: bold;
  margin: 0;
}
.details-prix {
  color: darkorange;
  font-size: 25px;
  font-family: "Poppins";
  font-weight: bold;
  margin: 0;
}
.content-details-adresse {
  padding-top: 15px;
  padding-left: 14%;
  padding-right: 14%;
  background-color: #edf1f6;
  display: flex;
  justify-content: space-between;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-bottom: 15px;
}
.content-details-description {
  padding-top: 15px;
  padding-left: 14%;
  padding-right: 14%;
  background-color: #f5f8fc;
  display: flex;
  justify-content: space-between;
  display: flex;
  justify-content: space-between;
}
.value-details {
  color: #2da9c5;
  font-weight: 700;
}

.btn-action-conseiller {
  background-color: #2da9c5 !important;
  color: white;
  border-radius: 8px;
  border: 0px;
  width: auto;
  padding: 5px 30px 5px 30px;
  border: 1px solid white;
  background-color: transparent;
  height: 44px;
  width: auto;
}
.form-achat {
  height: 40px;
  margin-bottom: 6px;
  border-radius: 5px;
  border: 2px solid white;
}

.content-conseiller {
  width: 30%;
  text-align: center;
  padding-left: 4%;
}
.info {
  padding: 0 !important;
  width: auto !important;
  font-size: 14px !important;
  padding: 0px 10px !important;
}
.content-details-description-mobile {
  width: 100%;
}
button.btn.btn-action-conseiller.info.btn-secondary {
  white-space: nowrap;
}

@media (min-width: 769px) and (max-width: 1100px) {
  .content-details-description {
    padding-left: 8%;
    padding-right: 8%;
  }

  button.btn.btn-action-conseiller.info.btn-secondary {
    overflow-x: scroll;
  }
  ::-webkit-scrollbar {
    background-color: transparent !important;
    border: transparent !important;
    color: transparent !important;
    width: 0px;
  }

  .card-details {
    background-color: white;
    width: 20%;
  }
  .btn-action-conseiller-mobile {
    flex-direction: column;
  }
  .btn-action-conseiller {
    white-space: nowrap;
    padding: 5px 17px 5px 17px;
    width: 100% !important;
  }
  .message {
    width: 100% !important;
    padding: 0px;
  }
}

@media (max-width: 768px) {
  .content-title {
    width: 100%;
  }
  .content-details-adresse {
    padding-bottom: 4%;
    display: grid;
    place-content: center;
  }
  .data-desc {
    text-align: center;
  }
  .data-desc li {
    list-style-type: none;
  }
  .content-details-description {
    flex-direction: column;
    padding-left: 4%;
    padding-right: 4%;
  }
  .content-details-description-mobile {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .content-conseiller {
    width: 100%;
  }
  .content-title-desc {
    text-align: center;
    margin-top: 0px;
  }
  .card-details {
    background-color: white;
    width: 40%;
    margin-right: 5px;
    margin-left: 5px;
  }
  .content-title-vendeur.mb-5 {
    margin-top: 50px;
    text-align: center;
  }

  .content-title-description-mobile {
    justify-content: center;
  }
  .content-title-description {
    padding: 9px 0px 25px 0px;
  }
  .btn-action-conseiller-mobile {
    flex-direction: column;
    align-items: center;
  }
  .info {
    width: 100% !important;
  }

  .btn-action-conseiller {
    width: 100%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}

img {
  height: 600px;
  width: 100%;
}

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 40%;
  width: auto;
  /* padding: 16px; */
  /* color: #504040; */
  font-weight: bold;
  font-size: 18px;
  transition: 0.7s ease;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  color: #2da9c5;
}

.next {
  right: -10px;
}

.prev {
  left: -10px;
}

.prev:hover,
.next:hover {
  background-color: darkorange;
  color: white;
}

.test {
  font-size: 20px;
  text-align: center;
  
  height: 335px;
}
.content-slide-details {
  min-height: 550px !important;
  max-height: 550px !important;
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 1%;
}
.slide-backroung-details {
  width: 100%;
  /* background-repeat: round; */
  background: center;
  width: 100%;

  background-size: cover;
  border-radius: 10px;
  overflow: hidden;
}
.slide-backroung::before {
}
.titre_slide {
  color: white;
  font-family: "Poppins";
  font-size: 50px;
}
.sous_titre_slide {
  color: white;
  font-family: "Poppins";
  font-weight: bold;
  font-size: 106px;
  margin-bottom: -10px;
}
.container-title-slide {
  display: flex;
  align-items: center;
  height: 335px;
}
.desc_sous_titre_slide {
  color: white;
  font-family: "Poppins";
  font-size: 26px;
  font-weight: Thin;
  text-align: right;
}
.parent-title {
  text-align: left;
  padding-left: 15%;
}
.title-tab {
  font-size: 16px;
  color: #4b4b4b;
  font-weight: 700;
  /* padding: 25px 10px 25px 25px; */
}
.btn-estimer {
  background-color: #2da9c5;
  color: white;
  border-radius: 5px;
  border: 0px solid white;
}
.btn-estimer:hover {
  background-color: darkorange;
  color: white;
  border-radius: 5px;
  border: 0px solid white;
}

.content-other-img {
  height: 100px !important;
  max-width: 100%;
  width: 100% !important;
  background-size: cover;
  border-radius: 10px;
  overflow: hidden;
  min-width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: auto;
  opacity: 1;
  /* padding-right: 15%; */
}

.img-active {
  border: 1px solid darkorange;
}

@media (max-width: 768px) {
  .content-slide-details {
    min-height: 550px !important;
    max-height: 550px !important;
  }
  .other-img {
    top: 60px;
  }
  .content-other-img {
    min-width: 20vw;
  }
  .parent-title {
    position: initial !important;
    width: 100%;
    margin: auto auto;
    display: flex !important;
    justify-content: center;
  }

  .container-other-img .next {
    top: 4vh !important;
  }
  .container-other-img .prev {
    top: 4vh !important;
  }
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: darkorange !important;
  color: white !important;
}
.nav-tabs .nav-link {
  background-color: #2da9c5 !important;
  color: white !important;
  border-color: none !important;
  border: 0px solid white !important;
  width: 150px;
  text-align: center;
}
.tab-content {
  padding: 14px 19px 8px 15px;
  width: 1225px;
}
.container-other-img {
  border-radius: 10px;
  padding: 1%;
  align-items: flex-start;
}
.other-img {
  top: 24px;
  width: 85%;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 0 0 0 0 0 0;
}

.container-other-img {
  border-radius: 10px;
  padding: 1%;
  align-items: flex-start;
}

.container-other-img:nth-child(1) {
  visibility: visible !important;
}
.container-other-img:nth-child(2) {
  visibility: visible !important;
}

.container-other-img:nth-child(3) {
  visibility: visible !important;
}

.container-other-img:nth-child(4) {
  visibility: visible !important;
}

.container-other-img:nth-child(5) {
  visibility: visible !important;
}

.container-other-img:nth-child(n) {
  visibility: hidden;
}
.transition-content {
  height: 350px;
  padding-top: 17px;
}
@media (max-width: 768px) {
  .slide-backroung-details.test {
    height: 40vh !important;
  }
  .other-img {
    top: 0px;
  }
  .transition-content {
    height: 350px;
    padding-top: 22px;
  }
}
</style>
